import React, { useRef, useState, useEffect } from "react";
import "./ContactComponents.css";
import emailjs from "@emailjs/browser";
import Toast from "../../Toast/Toast";
import { contactQuery } from "../../../sanity/queries";
import { sanityClient } from "../../../sanity/client";

const JoinLegacyForm = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [content, setContent] = useState(null);

  useEffect(() =>{
    sanityClient.fetch(contactQuery).then(setContent);
  },[])

  if (!content) return null;

  const handleSubmit = (e) => {
    e.preventDefault();

    // Honeypot check (BOT DETECTION)
    const honeypot = formRef.current.querySelector('input[name="company"]');
    if (honeypot && honeypot.value) {
      return;
    }
    setLoading(true);

    emailjs
      .sendForm(
         process.env.REACT_APP_EMAILJS_SERVICE_ID,
         process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
         formRef.current,
         process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setToast({
          type: "success",
          message: content.successMessage,
        });
        formRef.current.reset();
      })
      .catch(() => {
        setToast({
          type: "error",
          message: content.errorMessage,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="join-legacy-card">
        <div className="join-legacy-header">
          <span className="legacy-sub">{content.title}</span>
          <h2 className="legacy-title">
            {content.subtitle}
            <br />
            {content.description}
          </h2>
        </div>

        <form ref={formRef} onSubmit={handleSubmit}>
          <input
            type="text"
            name="company"
            tabIndex="-1"
            autoComplete="off"
            style={{ display: "none" }}
          />
          <div className="legacy-form-grid">

            <div className="form-group">
              <label className="form-label">Nombre</label>
              <input name="name" type="text" className="legacy-input" required />
            </div>

            <div className="form-group">
              <label className="form-label">Correo Electrónico</label>
              <input name="email" type="email" className="legacy-input" required />
            </div>

            <div className="form-group">
              <label className="form-label">Teléfono</label>
              <input name="phone" type="tel" className="legacy-input" required />
            </div>

            <div className="form-group">
              <label className="form-label">Programa de Interés</label>
              <select name="program" className="legacy-select" required>
                <option value="">Selecciona una opción</option>
                {content.programOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group full-width">
              <label className="form-label">Mensaje</label>
              <textarea
                name="message"
                className="legacy-textarea"
                rows="4"
                required
              />
            </div>

          </div>

          <button className="btn-submit" type="submit" disabled={loading}>
            {loading ? (
              <>
                <div className="spinner" />
                Enviando...
              </>
            ) : (
              <span>{content.submitText}</span>
            )}
          </button>
        </form>
      </div>

      {toast && (
        <Toast
          type={toast.type}
          message={toast.message}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
};

export default JoinLegacyForm;
